import '@/context'
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import i18n from '@/i18n'
import './plugins'
import '@/components/export'
import req from './utils/request'

import '@/icon/index'

import 'moment/locale/zh-cn'
import moment_tz from 'moment-timezone'

import VueCodeMirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/base16-light.css'
import 'codemirror/mode/vue/vue'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/mode/groovy/groovy'

import print from '@/components/vue-print-nb/print'
Vue.use(print)
Vue.use(VueCodeMirror)

import FlowChart from '@/components/flow/FlowChart'
Vue.use(FlowChart)

const env = process.env.VUE_APP_ENV

sessionStorage.setItem('env', env)

Vue.filter('timezoneDateFormat', function (value) {
  if (!value) {
    return ''
  }

  let a = moment_tz.tz.guess()
  let res = moment_tz
    .utc(moment_tz.utc(value))
    .tz(a)
    .format('YYYY-MM-DD HH:mm:ss')

  // 返回出 年-月-日 时:分:秒
  return res
})

Vue.filter('timeLag', function (difference) {
  let r = '',
    ////计算出相差天数
    days = Math.floor(difference / (24 * 3600 * 1000)),
    //计算出小时数
    leave1 = difference % (24 * 3600 * 1000), //计算天数后剩余的毫秒数
    hours = Math.floor(leave1 / (3600 * 1000)),
    //计算相差分钟数
    leave2 = leave1 % (3600 * 1000), //计算小时数后剩余的毫秒数
    minutes = Math.floor(leave2 / (60 * 1000)),
    //计算相差秒数
    leave3 = leave2 % (60 * 1000), //计算分钟数后剩余的毫秒数
    seconds = Math.round(leave3 / 1000)
  if (days > 0) r += days + '天'
  if (hours > 0) r += hours + '小时'
  if (minutes > 0) r += minutes + '分钟'
  if (seconds > 0) r += seconds + '秒'
  if (!r) {
    return '0秒'
  }
  return r
})

Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return req
  },
})
const app = new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
})

export function t() {
  let locale = app.$i18n.locale
  let localLang = localStorage.getItem('lang')

  if (locale && localLang && locale !== localLang) {
    app.$i18n.locale = localLang
  }

  return app.$t.apply(app, arguments)
}

export default app
